<template>
    <div class="wrapper">
        <el-table class="table" :data="cartProducts">
            <el-table-column min-width="40%" label="商品">
                <template slot-scope="scope">
                    <div class="product">
                        <img :src="host + '/' + scope.row.goods_thumb" alt="">
                        <!--<div>-->
                        <!--<span>{{scope.row.goods_name}}</span>-->
                        <!--<span>商品规格：{{scope.row.product.standard}}</span>-->
                        <!--<span>商品编号：{{scope.row.product.number}}</span>-->
                        <!--</div>-->
                        <div>
                            {{scope.row.goods_name}}
                            <pre style="font-size: 12px;margin: 0; line-height: 1.5">{{scope.row.goods_attr}}</pre>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column min-width="10%" label="单价">
                <template slot-scope="scope">
                    <span style="color: #f74845">
                        ￥{{Number(scope.row.goods_price_no).toFixed(2)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column min-width="20%" label="数量" prop="goods_number">
                <template slot-scope="scope">
                    <div>
                        <el-input-number
                            @change="(val) => handleChange(val, scope.row)"
                            v-model="scope.row.goods_number"
                            size="mini"
                            :min="0"
                            :max="Number(scope.row.sale_of_goods_inventory)"
                        ></el-input-number>
                        <div style="color: gray;"> 库存{{scope.row.sale_of_goods_inventory}}件</div>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column min-width="15%" label="修改价">
                <template slot-scope="scope">
                    <div class="editPrice">
                        <el-input
                            @change="(val) => modifyChange(val, scope.$index)"
                            v-model="scope.row.modify"
                            placeholder="修改价">
                            <span slot="prefix">￥</span>
                        </el-input>
                        <div style="color: gray">
                            范围：{{Number(scope.row.goods_price_no)-Number(scope.row.goods_preferential_spreads)}} - {{Number(scope.row.goods_price_no)}}
                        </div>
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column min-width="15%" label="操作">
                <template slot-scope="scope">
                    <Popover
                        :list="scope.row.goods_attr_list"
                        :goods_id="scope.row.goods_id"
                        :getCartProducts="getCartProducts"
                        :rec_id="scope.row.rec_id"
                        :qtyRaw="scope.row.goods_number"
                    >
                        <el-button
                            class="editBtn"
                            @click="getAttrList(scope.row.goods_id, scope.$index)">
                            编辑
                        </el-button>
                    </Popover>
                    <div>
                        <el-popover
                            :ref="scope.row.rec_id"
                            placement="left"
                            width="100"
                            :value="delVisibleId === scope.row.rec_id"
                        >
                            <p style="text-align: center">确定删除吗？</p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="delVisibleId=''">取消</el-button>
                                <el-button
                                    :loading="btnLoading"
                                    v-on:click="delCartProduct(scope.row.rec_id)"
                                    type="primary"
                                    size="mini">确定
                                </el-button>
                            </div>
                            <el-button class="delBtn" slot="reference" @click.stop="delVisibleId=scope.row.rec_id">删除
                            </el-button>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-button @click="addcar()">
            <i class="el-icon-circle-plus-outline"></i>添加商品
        </el-button>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Popover from './Popover.vue';
    import { host, getAttrList, setCartProducts } from '../../stores/api';

    Vue.component('Popover', Popover);
    export default {
        props: ['cartProducts', 'getCartProducts'],
        data () {
            return {
                btnLoading: false,
                delVisibleId: '',
                host: host,
//                attr_list: [],
            };
        },
        methods: {
            async handleChange (val, params) {
                const {rec_id} = params;
                return setCartProducts(rec_id, val);
            },
            modifyChange (val, index) {
                const {goods_preferential_spreads, goods_price_no} = this.cartProducts[index];
                if (!isNaN(Number(val))) {
                    if (Number(val) < Number(goods_price_no) - Number(goods_preferential_spreads)) {
                        this.cartProducts[index].modify = Number(goods_price_no) - Number(goods_preferential_spreads);
                    } else if (Number(val) > Number(goods_price_no)) {
                        this.cartProducts[index].modify = Number(goods_price_no);
                    } else {
                        this.cartProducts[index].modify = Number(val);
                    }
                } else {
                    this.cartProducts[index].modify = Number(goods_price_no);
                }
            },
            delCartProduct (rec_id) {
                this.btnLoading = true;
                this.handleChange(0, {rec_id}).then(async () => {
                    await this.getCartProducts();
                    this.$notify.success({
                        title: '操作成功',
                        message: '已删除商品'
                    });
                }).catch((err) => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message
                    });
                }).then(() => {
                    this.btnLoading = false;
                    this.delVisibleId = '';
                });
            },
            async getAttrList (goods_id, index) {
                //请求一次标识
                if (!this.cartProducts[index].getFlag) {
                    const goods_attr_ids = this.cartProducts[index].goods_attr_id.split(',');
                    return getAttrList(goods_id).then(res => {
                        this.cartProducts[index].goods_attr_list = res.data.map((item, index) => ({
                            ...item,
                            currId: goods_attr_ids[index]
                        }));
                        this.cartProducts[index].getFlag = true;
                    });
                }
            },
            //添加到购物车
            addcar(){
                localStorage.removeItem('order_id');
                this.$router.push('/SupplyChain/AddProduct')
            }
        },
        watch: {
//            cartProducts (val, old) {
//                this.attr_list = val.map(item => ({
//                    ...item,
//                    goods_attr_list: [],
//                    getFlag: false,
//                    modify: Number(item.goods_price_no)
//                }));
//            }
        },
    };
</script>

<style lang="less" scoped>
    @import "../../default";

    .wrapper {
        background: #fff;
        border: 1px solid #d8dde6;
        text-align: center;
        .table {
            /deep/ .cell {
                text-align: center;
            }

            /deep/ td {
                color: @font_black;
                padding: 16px 0;
                vertical-align: top;
                .editPrice {
                    .el-input {
                        width: 118px;
                        height: 32px;
                        border-radius: 2px;
                        input {
                            text-align: center;
                        }
                        .el-input__prefix {
                            left: 14px;
                            top: 2.5px;
                            font-size: 12px;
                            color: #f74845;
                        }
                        .el-input__inner {
                            height: 30px;
                            padding-right: 0;
                            padding-left: 0;
                            background-image: linear-gradient(-180deg, #ffffff 0%, #f7f7f7 100%);
                            font-size: 14px;
                            color: #f74845;
                            border-radius: 2px;
                            border: 1px solid #d8dde6;
                        }
                    }
                }
                .btn {
                    width: 80px;
                    height: 28px;
                    border-radius: 4px;
                    font-size: 14px;
                    border: 0;
                    padding: 0;
                    margin-bottom: 3px;
                }
                .editBtn {
                    .btn;
                    color: #FFF !important;
                    background: @orange;
                }
                .delBtn {
                    .btn;
                    color: @font_gary;
                    background: #fff;
                }
            }

            .product {
                display: flex;
                & > img {
                    width: 90px;
                    height: 90px;
                    margin: 0 15px;
                    border: 1px solid #dee0e0;
                }
                & > div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    text-align: left;
                    & > span:nth-child(2), & > span:nth-child(3) {
                        font-size: 12px;
                        color: @font_gary;
                    }
                }
            }
        }

        & > button {
            width: 398px;
            height: 46px;
            margin: 35px 0;
            padding: 0;
            font-size: 16px;
            color: #f74845;
            border: 1px solid #f74845;
            background: #fff;
            border-radius: 2px;
            i {
                font-size: 18px;
                margin-right: 8px;
            }
        }
    }

</style>




// WEBPACK FOOTER //
// src/components/SupplyCh/Product.vue